// extracted by mini-css-extract-plugin
export default {"search-box":"search-bar_search-box__AEoiz","input-base":"search-bar_input-base__3WMfw","search-icon":"search-bar_search-icon__xn5q0"};